export enum InstructionPopUpMode {
    ADD = 'Add',
    EDIT = 'Edit'
}

export const INSTRUCTION_TITLE = {
    ADD_INSTRUCTIONS: 'Add Instructions',
    EDIT_INSTRUCTIONS: 'Edit Instructions'
}